var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirecrackersAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.91046 6.8974C3.91046 4.19264 6.08346 2 8.764 2C11.1366 2 13.1614 3.7308 13.5515 6.09227L13.791 7.54217H16.0896C17.1447 7.54217 18 8.40523 18 9.46988V10.8866C14.9016 11.8393 11.6838 12.3335 8.44777 12.3552V9.46988C8.44777 8.40523 9.30311 7.54217 10.3582 7.54217H12.3384L12.1382 6.32996C11.8632 4.66563 10.4362 3.44578 8.764 3.44578C6.87479 3.44578 5.34329 4.99112 5.34329 6.8974V8.0241C5.34329 8.42334 5.02254 8.74699 4.62688 8.74699C4.23121 8.74699 3.91046 8.42334 3.91046 8.0241V6.8974Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44775 14.2829C11.679 14.2625 14.8931 13.7962 18 12.8968V15.4641C14.9089 16.4819 11.6908 17.0395 8.44775 17.1225V14.2829Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.4861C14.8995 18.4466 11.6852 18.9724 8.44775 19.0508V20.0723C8.44775 21.1369 9.30309 22 10.3582 22H16.0896C17.1447 22 18 21.1369 18 20.0723V17.4861Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17823 10.9449C4.458 10.6626 4.458 10.2049 4.17823 9.92257C3.89845 9.64027 3.44484 9.64027 3.16506 9.92257L2.20983 10.8864C1.93006 11.1687 1.93006 11.6264 2.20983 11.9088C2.48961 12.1911 2.94322 12.1911 3.223 11.9088L4.17823 10.9449Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0755 9.92257C4.79572 10.2049 4.79572 10.6626 5.0755 10.9449L6.03072 11.9088C6.3105 12.1911 6.76411 12.1911 7.04389 11.9088C7.32367 11.6264 7.32367 11.1687 7.04389 10.8864L6.08866 9.92257C5.80888 9.64027 5.35527 9.64027 5.0755 9.92257Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34329 12.3614C5.34329 11.9622 5.02254 11.6386 4.62688 11.6386C4.23121 11.6386 3.91046 11.9622 3.91046 12.3614V13.3253C3.91046 13.7245 4.23121 14.0482 4.62688 14.0482C5.02254 14.0482 5.34329 13.7245 5.34329 13.3253V12.3614Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirecrackersAlt2);
export default __webpack_public_path__ + "static/media/firecrackers-alt-2.6e58c8b0a68673bdc5827d0be6269911.svg";
export { ForwardRef as ReactComponent };